<template>
  <div class="container">
    <ald-text :font-size="32">{{ $t('message.generic.webConstruction') }}</ald-text>
    <div class="wrapper">
      <img class="wrapper-image" :src="underConstruction" alt="Under construction" />
    </div>
    <Links />
  </div>
</template>

<script>
import UnderConstruction from 'assets/images/under_construction.jpg';
import Links from '../../main/Links';

export default {
  components: {
    Links
  },

  data() {
    return {
      underConstruction: UnderConstruction
    };
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding-top: 20px;
  padding-bottom: 20px;

  .wrapper {
    margin: 30px 0 0;

    &-image {
      max-width: 100%;
      height: auto;
    }
  }
}
</style>
